import React from 'react';
import { observer } from 'mobx-react';
import { OnboardingNativeLanguageWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import Button from 'components/button/button';
import ListSelect from 'components/list_select';
import OnboardingContent from 'components/onboarding/onboarding_content';
import OnboardingWrapper from 'components/onboarding/onboarding_wrapper';
import OnboardingIllustration from 'components/onboarding/onboarding_illustration';
import withRouteParams from 'utils/with_route_params';

const Continue = styled.div`
  margin-top: 20px;
`;

const LanguageListScroll = styled.div`
  width: 100%;
  height: 360px;
  max-height: calc(100vh - 330px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 6px;
  box-sizing: border-box;
`;

@observer
class OnboardingNativeLanguage extends React.Component {
  onSubmit = () => {
    this.props.onSubmit();
    const route = AppUI.user.signedOut ? 'onboarding.registration' : 'onboarding.referrer';
    AppUI.routeStore.routeToNamed(route, {languageId: this.props.params.languageId});
  }

  render() {
    return (
      <OnboardingWrapper>
        <OnboardingIllustration
          text={this.props.languageId !== 'EN' ? this.props.languageMessage : 'What is your native language?'}
          languageId={AppUI.targetLanguageId}
          reaction={this.props.languageId !== 'EN' ? 'happy' : 'disappointed'}
          marginBottom={20}
        />
        <OnboardingContent>
          <LanguageListScroll>
            <ListSelect
              value={this.props.languageId}
              options={AppUI.AiLanguageOptionsForFilter}
              onSelect={this.props.onSetNativeLanguageId}
              fieldName='name'
            />
          </LanguageListScroll>
        </OnboardingContent>
        <Continue>
          <Button
            onClick={this.onSubmit}
            width='440px'
            height='60px'
          >
            Continue
          </Button>
        </Continue>
      </OnboardingWrapper>
    );
  }
}

export default withRouteParams(OnboardingNativeLanguageWrapper(OnboardingNativeLanguage));
